import { IPromotion } from 'common/promotion';
import { IItinerary } from 'common/types';
import { TripType } from 'contexts/searchParams';
import ErrorState from 'list/common/error';
import NoResult from 'list/common/noResult';
import ResetFilter from 'list/common/resetFilter';
import MultipleList from './multiple';
import OneWayList from './oneWay';
import RoundTripList from './roundTrip';
import { IInternationalContextResult, SelectTypeKeys } from './types';
import classNames from 'classnames/bind';

import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface IInternationalListContainerProps {
  allSelected: boolean;
  error: any;
  fareType: string;
  flightResult: IInternationalContextResult;
  itinerary: IItinerary[];
  noResult: boolean;
  promotions: IPromotion[];
  samePriceOrgSch?: string;
  scheduleTitles: string[];
  selectType: SelectTypeKeys;
  selectedFlightList: [string, string, string][];
  tripType: TripType;
  showLoading?: boolean;
  allDetailLoaded?: boolean;
  onReset: () => void;
  selectFlight: (
    index: number,
    sch: string,
    fareType: string,
    airline: string,
    labels: string[],
  ) => void;
  selectFlights: (
    schs: string,
    fareType: string,
    airline: string,
    labels: string[],
  ) => void;
  setMinFare: React.Dispatch<React.SetStateAction<number | undefined>>;
}

const nullFunc = () => null;
const containers = {
  [TripType.OW]: OneWayList,
  [TripType.RT]: RoundTripList,
  [TripType.MD]: MultipleList,
  [TripType.EVERYWHERE]: nullFunc,
  [TripType.NULL]: nullFunc,
};

const InternationalListContainer = ({
  allSelected,
  error,
  fareType,
  flightResult,
  itinerary,
  noResult,
  promotions,
  samePriceOrgSch,
  scheduleTitles,
  selectType,
  selectedFlightList,
  tripType,
  showLoading,
  allDetailLoaded,
  onReset,
  selectFlight,
  selectFlights,
  setMinFare,
}: IInternationalListContainerProps) => {
  if (allSelected) return null;

  if (showLoading) {
    return (
      <div
        className={cx('list_loading_area', allDetailLoaded && 'detail_loaded')}
        aria-label="Loading..."
        aria-busy="true"
      />
    );
  }

  if (!flightResult || error) return <ErrorState />;

  if (noResult) return <NoResult />;

  if (!flightResult.fares.size) {
    return <ResetFilter onReset={onReset} setMinFare={setMinFare} />;
  }

  const List = containers[tripType];

  return (
    <List
      fareType={fareType}
      flightResult={flightResult}
      itinerary={itinerary}
      promotions={promotions}
      samePriceOrgSch={samePriceOrgSch}
      scheduleTitles={scheduleTitles}
      selectType={selectType}
      selectedFlightList={selectedFlightList}
      tripType={tripType}
      selectFlight={selectFlight}
      selectFlights={selectFlights}
      setMinFare={setMinFare}
    />
  );
};

export default InternationalListContainer;
